import { render, staticRenderFns } from "./Blocked.vue?vue&type=template&id=70791677&scoped=true&"
import script from "./Blocked.vue?vue&type=script&lang=js&"
export * from "./Blocked.vue?vue&type=script&lang=js&"
import style0 from "./Blocked.vue?vue&type=style&index=0&id=70791677&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70791677",
  null
  
)

export default component.exports